// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useContext, useState, useLayoutEffect } from 'react';
import { useResizeObserver } from '../../hooks';
import VerticalContext, { VERTICAL_BREAKPOINT } from '../VerticalContext';
const isVertical = containerRef => {
  if (!containerRef.current) {
    return false;
  }
  const {
    width
  } = containerRef.current.getBoundingClientRect();
  return width < VERTICAL_BREAKPOINT;
};
export const useVertical = (externalVertical, containerRef) => {
  const verticalContext = useContext(VerticalContext);
  const [internalVertical, setInternalVertical] = useState(false);
  useLayoutEffect(() => {
    setInternalVertical(isVertical(containerRef));
  }, [containerRef]);
  useResizeObserver({
    ref: containerRef,
    onResize: () => {
      setInternalVertical(isVertical(containerRef));
    },
    callOnInit: false
  });
  const vertical = [externalVertical, verticalContext, internalVertical].find(v => typeof v === 'boolean');
  return vertical;
};